import { BuildUri } from "./BuildUri";

import { Client, SimpleClient } from "../model/Client";
import { PatchRequest } from "../requests/PatchRequest";
import { ClientRequest } from "../requests/ClientRequest";

import context from "../context";

class ClientEndpoints {

    getClientList(): Promise<Array<SimpleClient>> {
        return context.fetch(
            BuildUri("/client")
        );
    }

    getClient(clientId: number): Promise<Client> {
        return context.fetch(
            BuildUri("/client/{clientId}", {clientId})
        );
    }

    createClient(request: ClientRequest): Promise<Client> {
        return context.fetch(
            BuildUri("/client"),
            {
                method: "POST",
                body: request
            }
        );
    }

    editClient(clientId: number, request: ClientRequest): Promise<Client> {
        return context.fetch(
            BuildUri("/client/{clientId}", {clientId}),
            {
                method: "PUT",
                body: request
            }
        );
    }

    setClientArchivedStatus(clientId: number, request: PatchRequest): Promise<Client> {
        return context.fetch(
            BuildUri("/client/{clientId}", {clientId}),
            {
                method: "PATCH",
                body: request
            }
        );
    }

    getBadgePreview(clientId: number): Promise<Response> {
        return context.fetch(
            BuildUri("/client/{clientId}/badge/preview", {clientId})
        );
    }
}

export default new ClientEndpoints();
